import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {ToasterService} from 'angular2-toaster';

import {applicationStatus} from '../compare/compare.service'

@Injectable({
    providedIn: 'root'
})

export class ErrorService {

    constructor(
        private router: Router,
        public toasterService: ToasterService,
    ) {
    }

    errorHandlerOnGetDetailOfLoan(err) {
        if (err.error.errorType === 'GENERIC') {
            if (err.status === 404) {
                this.toasterService.pop('error', 'Alert', err.error.message);
                this.router.navigate(['/error']);
            }
        }
        if (err.error.errorType === 'VALIDATION') {

        }
    }

    checkPath(loanstatus, loanId) {
        if (loanstatus === applicationStatus.CIBIL_APPLIED ||
            loanstatus === applicationStatus.CIBIL_APPROVED ||
            loanstatus === applicationStatus.DISBURSED ||
            loanstatus === applicationStatus.REJECTED  ) {
            this.router.navigateByUrl(`/loanApplication/${loanId}/status`);
        }
        /*if (loanstatus === applicationStatus.KYC) {
            this.router.navigateByUrl(`/loanApplication/${loanId}/kyc`);
        }*/
    }
}
